var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "placeholder-paragraph"
  }, _vm._l(_vm.calcRows, function (row) {
    return _c('div', {
      key: row,
      staticClass: "bg-dark mb-2"
    });
  }), 0);
};
var staticRenderFns = [];
export { render, staticRenderFns };